import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatCNPJ, formatDate } from 'utils/formatDate';
import { formatCPF } from 'utils/formatters';
import { useStoreSelector } from 'v3/data/store';
import { ContractingStateEnum } from 'v3/data/store/contracting/enums';
import { ContractingStateMapping } from 'v3/data/store/contracting/mapping';
import { ContractingType } from 'v3/data/store/contracting/types';
import { StoreProfileEnum } from 'v3/data/store/stores/enums';
import { RoutesEnum } from 'v3/routes/enum';
import { SubtitleMediumBold } from 'v3/shared/typography/SubtitleMedium';
import {
  AlignClientInfo,
  AlignValues,
  BodyLine,
  HeaderLine,
  Line,
  MainContainer,
  SeeMoreContainer,
  SubtitleLine,
} from '../styles';

interface IMobileTable {
  contractingList: ContractingType[];
}

export const ContractingMobileTable: React.FC<IMobileTable> = ({ contractingList }) => {
  const navigate = useNavigate();

  const { group } = useStoreSelector((store) => store.store.storeLogged);
  const isStore = group === StoreProfileEnum.STORE;

  const handleNavigation = (contractingKey: string) => {
    navigate(`${RoutesEnum.Contracting}/${contractingKey}`);
  };

  return (
    <Fragment>
      {contractingList.map((contracting) => {
        const { fullName, cpf } = contracting.person;
        const { name } = contracting.creditSimulation.store;
        const formattedCNPJ = formatCNPJ(contracting.creditSimulation.store.cnpj);
        const { date, time } = formatDate(contracting.createdAt);
        const formattedCPF = formatCPF(cpf);
        const contractingStatusTitle =
          ContractingStateMapping[contracting.status as ContractingStateEnum]?.title || 'Status desconhecido';

        return (
          <MainContainer key={contracting.contractingKey} onClick={() => handleNavigation(contracting.contractingKey)}>
            <AlignValues>
              <HeaderLine>Cliente</HeaderLine>
              <AlignClientInfo>
                <BodyLine>{fullName}</BodyLine>
                <SubtitleLine>{formattedCPF}</SubtitleLine>
              </AlignClientInfo>
            </AlignValues>
            {!isStore && (
              <AlignValues>
                <HeaderLine>Loja</HeaderLine>
                <AlignClientInfo>
                  <BodyLine>{name}</BodyLine>
                  <SubtitleLine>{formattedCNPJ}</SubtitleLine>
                </AlignClientInfo>
              </AlignValues>
            )}
            <AlignValues>
              <HeaderLine>Data e hora</HeaderLine>
              <AlignClientInfo>
                <BodyLine>{date}</BodyLine>
                <SubtitleLine>{time}</SubtitleLine>
              </AlignClientInfo>
            </AlignValues>
            <AlignValues>
              <HeaderLine>Status</HeaderLine>
              <AlignClientInfo>
                <BodyLine>{contractingStatusTitle}</BodyLine>
              </AlignClientInfo>
            </AlignValues>
            <Line />
            <SeeMoreContainer>
              <SubtitleMediumBold>Ver mais</SubtitleMediumBold>
              <ArrowForwardIosIcon />
            </SeeMoreContainer>
          </MainContainer>
        );
      })}
    </Fragment>
  );
};
